import { useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div className="app-container">
      <div className="px-4 py-6 pb-20">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <button onClick={() => navigate('/')} className="text-white">
            ← Back
          </button>
          <Heart className="text-primary fill-primary" size={24} />
          <div className="w-8" />
        </div>

        <h1 className="text-white font-bold text-3xl mb-6">Terms of Use</h1>

        <div className="space-y-6 text-gray-300 text-sm leading-relaxed">
          <section>
            <h2 className="text-white font-semibold text-lg mb-2">1. Age Requirement</h2>
            <p>You must be 18 years or older to use BlindMatch. By using this service, you confirm you meet this requirement.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">2. Entertainment Service</h2>
            <p>BlindMatch is provided as an entertainment service for anonymous dating. We facilitate connections but do not guarantee outcomes.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">3. No Identity Verification</h2>
            <p>We do not verify the identity, age, or authenticity of users beyond their email address. Exercise caution when interacting with matches.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">4. User Interactions</h2>
            <p>BlindMatch is not liable for any interactions, meetings, or relationships that occur as a result of using our service. You are solely responsible for your safety.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">5. Payment Policy</h2>
            <p>All payments are non-refundable once matches have been generated and delivered. Payments are processed securely through Razorpay (India) or Stripe (International).</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">6. Anonymous Communication</h2>
            <p>Your personal information (name, email) is never shared with your matches. You control what information you reveal in chat.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">7. Prohibited Conduct</h2>
            <p>Harassment, inappropriate content, spam, and fake profiles are prohibited. Violations may result in account termination without refund.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">8. Service Availability</h2>
            <p>We strive to provide reliable service but do not guarantee uninterrupted access. We reserve the right to modify or discontinue the service at any time.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">9. Limitation of Liability</h2>
            <p>BlindMatch and its operators are not liable for any damages, losses, or harm arising from use of this service.</p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-lg mb-2">10. Changes to Terms</h2>
            <p>We may update these terms at any time. Continued use of the service constitutes acceptance of updated terms.</p>
          </section>

          <section className="text-xs text-gray-500">
            <p>Last updated: January 2026</p>
          </section>
        </div>
      </div>
    </div>
  );
}
